export default __webpack_public_path__ + "static/media/knowledgebytes_icon.0bb236d5.svg";